<template>
  <b-modal
    class="cloudflare-turnstile-modal"
    :active="active"
    has-modal-card
    :can-cancel="true"
    :on-cancel="cancel"
  >
    <div class="modal-card">
      <header class="modal-card-head align-items">
        <p class="modal-card-title">
          Are you human?
        </p>
        <button
          id="cloudflare-turnstile-cancel"
          type="button"
          class="m-0"
          @click="cancel"
        >
          Cancel
        </button>
      </header>
      <section class="modal-card-body ">
        <CloudflareTurnstile @input="(token) => $emit('complete', token)" />
      </section>
    </div>
  </b-modal>
</template>

<script lang="ts">
import {
  Component,
  Vue,
} from 'vue-property-decorator'
import CloudflareTurnstile from './CloudflareTurnstile.vue'

@Component({
  components: {
    CloudflareTurnstile,
  },
})
export default class CloudflareTurnstileModal extends Vue {
  active = true

  mounted() {
    // eslint-disable-next-line no-console
    console.log('CLOUDFLARE TURNSTILE MODAL -- MOUNTED')
  }

  beforeDestroy() {
    // eslint-disable-next-line no-console
    console.log('CLOUDFLARE TURNSTILE MODAL -- DESTROYED')
  }

  cancel() {
    this.active = false
    this.$emit('cancel')
  }
}
</script>
